import React, { useState, useEffect } from 'react';
import './MartHero.css';

const MART_SLIDES = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1400&q=80',
    label: 'Fashion Trends',
    headline: 'Style That',
    sub: 'Defines You',
    caption: 'Exclusive clothing collection sourced from premium brands.',
    tag: '👕 Lifestyle',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=1400&q=80',
    label: 'Smart Tech',
    headline: 'Innovation in',
    sub: 'Every Gadget',
    caption: 'Next-gen electronics and smart accessories for your daily needs.',
    tag: '⌚ Electronics',
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1400&q=80',
    label: 'Premium Audio',
    headline: 'Feel the',
    sub: 'Real Sound',
    caption: 'Experience high-fidelity audio with our noise-cancelling range.',
    tag: '🎧 Accessories',
  }
];

const MartHero = ({ onShopNow }) => {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(timer);
  }, [active]);

  const handleNext = () => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setActive((prev) => (prev + 1) % MART_SLIDES.length);
      setAnimating(false);
    }, 500);
  };

  const handlePrev = () => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setActive((prev) => (prev - 1 + MART_SLIDES.length) % MART_SLIDES.length);
      setAnimating(false);
    }, 500);
  };

  const slide = MART_SLIDES[active];

  return (
    <section className="mh-root">
      {/* BACKGROUND LAYER */}
      <div className="mh-bg-wrap">
        {MART_SLIDES.map((s, i) => (
          <div
            key={s.id}
            className={`mh-bg-slide ${i === active ? 'active' : ''}`}
            style={{ backgroundImage: `url(${s.image})` }}
          />
        ))}
        <div className="mh-overlay" />
      </div>

      {/* TEXT CONTENT */}
      <div className={`mh-content ${animating ? 'exit' : 'enter'}`}>
        <div className="mh-tag">{slide.tag}</div>
        <div className="mh-eyebrow">{slide.label}</div>
        <h2 className="mh-headline">
          {slide.headline}<br />
          <span className="mh-accent">{slide.sub}</span>
        </h2>
        <p className="mh-caption">{slide.caption}</p>
        <div className="mh-actions">
          <button className="mh-cta-primary" onClick={onShopNow}>
            Explore Mart →
          </button>
        </div>
      </div>

      {/* NAVIGATION */}
      <button className="mh-arrow left" onClick={handlePrev}>‹</button>
      <button className="mh-arrow right" onClick={handleNext}>›</button>

      {/* COUNTER */}
      <div className="mh-counter">
        {String(active + 1).padStart(2, '0')} / {String(MART_SLIDES.length).padStart(2, '0')}
      </div>

      {/* STATS BAR (MATCHING AGRO STYLE) */}
      <div className="mh-stats-bar">
        {[
          { num: '500+', label: 'Products' },
          { num: '24hr', label: 'Dispatch' },
          { num: '100%', label: 'Genuine' },
          { num: '7-Day', label: 'Return' },
        ].map((st) => (
          <div key={st.label} className="mh-stat">
            <span className="mh-stat-num">{st.num}</span>
            <span className="mh-stat-label">{st.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MartHero;